import React, { useState, useEffect } from 'react';

interface RecordingTimerProps {
  isRecording: boolean;
}

const RecordingTimer: React.FC<RecordingTimerProps> = ({ isRecording }) => {
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (isRecording) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    } else {
      clearInterval(interval!);
    }

    return () => clearInterval(interval!);
  }, [isRecording]);

  useEffect(() => {
    if (!isRecording) {
      setTimer(0);
    }
  }, [isRecording]);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return <div>{formatTime(timer)}</div>;
};

export default RecordingTimer;
